/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferOutNote
 */
export interface OfferOutNote {
    /**
     * 
     * @type {string}
     * @memberof OfferOutNote
     */
    note: string;
    /**
     * 
     * @type {number}
     * @memberof OfferOutNote
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof OfferOutNote
     */
    modificationDate: Date;
}

export function OfferOutNoteFromJSON(json: any): OfferOutNote {
    return OfferOutNoteFromJSONTyped(json, false);
}

export function OfferOutNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferOutNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': json['note'],
        'offerId': json['offerId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function OfferOutNoteToJSON(value?: OfferOutNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
        'offerId': value.offerId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


